import { useState } from "react";
import { Helmet } from "react-helmet";
import "../../forex.css";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

const ForexSolutions = () => {
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const handleSlideChange = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  return (
    <div>
      <main className="vara_license_consultant">
        <NewHead />

        <Helmet>
          <title>Forex Trading Software Development</title>

          <meta name="title" content="Forex Trading Software Development" />
          <meta
            name="description"
            content="Explore smooth operation through licensing with expert vara license consultation service. Get through the complexities of VARA licensing effortlessly with our guidance. VARA License Consultation – your pathway to seamless licensing solutions developed just for you"
          />

          <meta
            property="og:title"
            content="Forex Trading Software Development "
          />
          <meta property="og:site_name" content="Beleaf Technologies" />

          <link
            rel="canonical"
            href="https://www.beleaftechnologies.com/forex-trading-software-development"
          />
        </Helmet>

        <main className="forex-section">
          <div className="forex-green">
            <section className="forex-hero">
              <div className="container">
                <div className="row">
                  <div className="text-center">
                    <h1 className="forex-hero-title forex-hero-title-mw">
                      Forex Trading Software Development
                    </h1>
                    <p className="primary-content-forex w-center forex-hero-pad-y">
                      Our company specializes in forex trading software
                      development, delivering advanced solutions to financial
                      institutions, and traders. With expertise in building
                      white-label forex trading platform, MT4 auto trading
                      software, and forex copy trading software.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="forex-primary-btn w-btn"
                    >
                      Get Consultation
                    </button>
                  </div>
                </div>
              </div>
            </section>
            {/* hero-img-section */}
            <section>
              <section className="forex-wrapper-two hero-img-pad ">
                <img
                  src={require("../../image/forex/forex-hero-imgNew.webp")}
                  alt="forex-graph"
                  loading="lazy"
                  className="forex-hero-img"
                />
              </section>
            </section>
            {/* forex-trading-software-development */}
            <section className="forex-trade-section graph-pad-b-150 ">
              <div className="text-center">
                <div className="outer-box">
                  <div className="Frame-15307">What is</div>
                </div>
                <h4 className="primary-title-forex">
                  Forex Trading Software Development?
                </h4>
              </div>
              <div className="forex-wrapper-two ">
                <div className="forex-graph-wrapper">
                  <div className="forex-graph-content">
                    <h5>
                      {" "}
                      Forex trading software development is a process of
                      developing a digital platform that allows traders to
                      engage in buying and selling currencies. It provides
                      essential tools and functionalities to manage trades,
                      analyze market data, and execute orders in real time.
                    </h5>
                    <h6>
                      Forex trading softwares can be highly specialised and
                      feature advanced capabilities like charting tools,
                      indicators, automated trading, and risk management tools.
                      Our forex trading software development company offers
                      advanced solutions for all these platforms to meet the
                      unique needs of your business.
                    </h6>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="forex-primary-btn w-btn know-more-auto"
                    >
                      Know More
                    </button>
                  </div>
                  <div className="forex-graph-img-wrapper">
                    <img
                      src={require("../../image/forex/forex-graphNew.webp")}
                      alt="forex-graph"
                      loading="lazy"
                      className="forex-graphNew"
                    />
                  </div>
                </div>
              </div>
            </section>
            {/* revenue-generating-section */}
            <section className="forex-wrapper-two graph-pad-b-150">
              <h4 className="primary-title-forex text-center max-mt-29 forex-why-mw">
                Revenue-Generating Factors of Forex Trading Software
              </h4>
              <p className="primary-content-forex w-42-center mb-5 text-center">
                Forex trading software offers several opportunities for
                businesses and traders to generate revenue. Here are the key
                revenue-generating factors
              </p>
              <div>
                <div className="forex-revenue">
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/moneyNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">Commission on Trades</h3>
                      <p>
                        Brokers can earn revenue by charging a commission on
                        each trade executed through their forex trading
                        software. Every time a trader buys or sells currency,
                        the broker receives a small fee. As trading volume
                        increases, so does the revenue.
                      </p>
                    </div>
                  </div>
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/expandNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">Spreads</h3>
                      <p>
                        A spread is the difference between the buying and
                        selling price of a currency pair. Brokers often add a
                        markup to the spread, which becomes their profit. The
                        larger the number of trades, the higher the revenue from
                        spreads.
                      </p>
                    </div>
                  </div>
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/subscriptionNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">
                        Subscription or Licensing Fees
                      </h3>
                      <p>
                        Forex trading platforms can offer premium features or
                        advanced tools through paid subscriptions. Traders pay
                        regular fees for access to these services, generating
                        steady income for the software provider.
                      </p>
                    </div>
                  </div>
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/onlineNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">Automated Trading Tools</h3>
                      <p>
                        Providing automated trading tools like MT4 auto trading
                        software can attract professional traders who rely on
                        advanced algorithms. Businesses can charge higher fees
                        for these sophisticated tools, increasing revenue.
                      </p>
                    </div>
                  </div>
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/data-analysisNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">
                        Market Data and Analysis Tools
                      </h3>
                      <p>
                        Forex trading software that offers real-time market
                        data, charts, and analysis tools can generate revenue by
                        charging traders for access to premium data or advanced
                        technical analysis tools.
                      </p>
                    </div>
                  </div>
                  <div className="revenue-green">
                    <div className="revenue-cards">
                      <img
                        src={require("../../image/forex/user-managementNew.webp")}
                        alt=""
                      />
                      <h3 className="earn-amt">Account Management Fees</h3>
                      <p>
                        Some brokers charge a fee for managing a trader's
                        account or for offering services like personalized
                        trading advice, adding to their revenue.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* our forex trading-section */}
            <section className="forex-wrapper-two our-forex graph-pad-b-150">
              <h4 className="primary-title-forex text-center forex-our-mw">
                Our Forex Trading Software Development Services
              </h4>
              <p className="primary-content-forex w-56-center mb-5 text-center">
                As a leading forex trading software development company, we
                provide an extensive range of services that includes everything
                from platform design to integration with liquidity providers.
              </p>

              <div className="forex-slider-parent">
                <div className="forex-slider-container">
                  <div className="forex-slider-inner">
                    <button
                      className={`custom-prev-arrow ${
                        isPrevDisabled ? "disabled" : ""
                      }`}
                      style={{
                        color: isPrevDisabled ? "grey" : "white",
                        cursor: isPrevDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="bi bi-chevron-left"></i>
                    </button>
                    <button
                      className={`custom-next-arrow ${
                        isNextDisabled ? "disabled" : ""
                      }`}
                      style={{
                        color: isNextDisabled ? "grey" : "white",
                        cursor: isNextDisabled ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="bi bi-chevron-right"></i>
                    </button>

                    <Swiper
                      spaceBetween={50}
                      slidesPerView={1}
                      modules={[Navigation, A11y, Pagination]}
                      pagination={{
                        clickable: true,
                        // el: ".forex-paginate",
                      }}
                      scrollbar={{ draggable: true }}
                      navigation={{
                        prevEl: ".custom-prev-arrow",
                        nextEl: ".custom-next-arrow",
                      }}
                      onSlideChange={handleSlideChange}
                      onReachBeginning={() => setIsPrevDisabled(true)}
                      onReachEnd={() => setIsNextDisabled(true)}
                      onFromEdge={() => {
                        setIsPrevDisabled(false);
                        setIsNextDisabled(false);
                      }}
                      speed={500}
                    >
                      <SwiperSlide className="text-white">
                        <h5 className="forex-slider-title">
                          <span>Custom </span> Forex Trading Platform
                          Development
                        </h5>
                        <p className="forex-slider-content">
                          We do custom forex trading software development that
                          are built from the ground up to meet your unique
                          requirements. Whether you are a broker looking for a
                          new platform or a trader in need of a personalized
                          solution, our team has the expertise to deliver
                          advanced, scalable, and secure software. Our platforms
                          come with the following features:
                        </p>
                        <div className="forex-star-wrapper">
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Advanced charting tools</h6>
                              <p>
                                For technical analysis and market forecasting.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Multi-device compatibility</h6>
                              <p>
                                Optimized for web, desktop, and mobile devices.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Risk management tools</h6>
                              <p>
                                Built-in systems to manage, margins, and
                                stop-loss orders.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Security</h6>
                              <p>
                                Top-level encryption and secure user
                                authentication protocols.
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="forex-slider-bottom-content">
                          Our custom solutions ensure that your forex trading
                          software aligns perfectly with your business model and
                          trading strategy.
                        </p>
                      </SwiperSlide>
                      <SwiperSlide className="text-white">
                        <h5 className="forex-slider-title">
                          <span>White Label </span>Forex Trading Platform
                          Development
                        </h5>
                        <p className="forex-slider-content">
                          For businesses looking to launch quickly and
                          efficiently, our white label forex trading platform
                          solutions offer the perfect balance of speed,
                          customization, and cost-effectiveness. With our white
                          label forex trading platform, you benefit from
                        </p>
                        <div className="forex-star-wrapper">
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Fully customizable branding</h6>
                              <p>
                                Make the platform look and feel like your own.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Quick deployment</h6>
                              <p>
                                Get your platform live in a matter of weeks.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Built-in features</h6>
                              <p>
                                Access advanced trading tools, market data, and
                                user management systems.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Regulatory compliance</h6>
                              <p>
                                We ensure that the platform complies with all
                                relevant regulations in your target markets.
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="forex-slider-bottom-content">
                          This option is ideal for brokers looking to enter the
                          forex market with a professional, fully operational
                          platform without the long development cycle.
                        </p>
                      </SwiperSlide>
                      <SwiperSlide className="text-white">
                        <h5 className="forex-slider-title">
                          <span>MT4 Auto </span>Trading software Development
                        </h5>
                        <p className="forex-slider-content">
                          We specialize in developing custom MT4 auto trading
                          software, which allows traders to automate their
                          trading strategies and execute trades 24/7 without
                          manual intervention. Our MT4 auto trading solutions
                          include
                        </p>
                        <div className="forex-star-wrapper">
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Expert Advisors (EAs)</h6>
                              <p>
                                These execute trades based on predefined rules
                                and parameters. We develop highly optimized EAs
                                for MT4 to help traders maximize their
                                profitability.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Algorithmic trading strategies</h6>
                              <p>
                                We can create sophisticated algorithms developed
                                to your trading style, whether you're scalping,
                                day trading, or swing trading.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Backtesting and optimization</h6>
                              <p>
                                We provide tools to test your strategies on
                                historical data to ensure they are effective
                                before going live.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Low-latency execution</h6>
                              <p>
                                Our systems are built to minimize delays in
                                trade execution, ensuring that trades are placed
                                at optimal market conditions.
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="forex-slider-bottom-content">
                          Our MT4 auto trading software allows traders to
                          capitalize on market opportunities, even when they're
                          not actively overseeing the platform.
                        </p>
                      </SwiperSlide>
                      <SwiperSlide className="text-white">
                        <h5 className="forex-slider-title">
                          <span>Mobile </span>forex trading apps Development
                        </h5>
                        <p className="forex-slider-content">
                          We develop mobile forex trading apps that offer the
                          same level of functionality as desktop platforms,
                          ensuring that traders can execute trades, analyze
                          data, and manage their accounts on the go. Our mobile
                          apps come with
                        </p>
                        <div className="forex-star-wrapper">
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Real-time alerts</h6>
                              <p>
                                Help traders make informed decisions with market
                                movements and account activity.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>User-friendly interface</h6>
                              <p>
                                Designed for a smooth mobile experience,
                                featuring simple navigation and quick loading
                                times.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Customizable dashboards</h6>
                              <p>
                                Allowing users to optimise the platform
                                according to their specific trading preferences.
                              </p>
                            </div>
                          </div>
                          <div className="forex-star-content">
                            <img
                              src={require("../../image/forex/forex-slider-star.webp")}
                              alt=""
                            />
                            <div>
                              <h6>Security features</h6>
                              <p>
                                Including two-factor authentication, encryption,
                                and secure login procedures.
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="forex-slider-bottom-content">
                          Our MT4 auto trading software allows traders to
                          capitalize on market opportunities, even when they're
                          not actively overseeing the platform.
                        </p>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </section>{" "}
            {/* Why Choose Us for Forex */}
            <section className="forex-wrapper-two graph-pad-b-150 ">
              {" "}
              <h4 className="primary-title-forex text-center why-mt-5 forex-why-mw">
                Why Choose Us for Forex Trading Software Development?
              </h4>
              <p className="primary-content-forex w-51-center mb-5 mt-4 text-center">
                Our company stands out in the industry as a top forex trading
                software development company due to our in-depth knowledge of
                the forex market, future technology, and a strong commitment to
                customer success. Here’s why clients choose us:
              </p>
              <div className="forex-choose-container forex-choose-translate1 ">
                <div className="forex-choose-width">
                  {/* <img
                    src={require("../../image/forex/forex-ad-settings.png")}
                    alt=""
                  />
                  <h5>advanced solution</h5> */}
                </div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper">
                    <img
                      src={require("../../image/forex/forex-ad-settingsNew.webp")}
                      alt=""
                    />
                  </div>
                  <h5>advanced solution</h5>
                </div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper">
                    <img
                      src={require("../../image/forex/forex-teamNew.webp")}
                      alt=""
                    />
                  </div>

                  <h5> Expert Development Team</h5>
                </div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper">
                    <img
                      src={require("../../image/forex/forex-end-endNew.webp")}
                      alt=""
                    />
                  </div>
                  <h5>End-to-End Services</h5>
                </div>
                <div className="forex-choose-width "></div>
              </div>
              <div className="forex-choose-container forex-choose-translate2 ">
                <div className="forex-choose-width "></div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper-lg">
                    <img
                      src={require("../../image/forex/forex-scalabilityNew.webp")}
                      alt=""
                    />
                  </div>
                  <h5>Scalability and Flexibility</h5>
                </div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper">
                    <img
                      src={require("../../image/forex/forex-customerNew.webp")}
                      alt=""
                    />
                  </div>
                  <h5> 24x7 Customer support</h5>
                </div>
                <div className="forex-choose-cards forex-choose-border">
                  <div className="forex-choose-cards-img-wrapper-lg">
                    <img
                      src={require("../../image/forex/forex-provenNew.webp")}
                      alt=""
                    />
                  </div>
                  <h5> Proven Track Record</h5>
                </div>
                <div className="forex-choose-width"></div>
              </div>
            </section>
            {/* Take away */}
            <section className=" graph-pad-b-150 ">
              <div className="forex-take-away-wrapper">
                <div className="forex-take-away-outer">
                  <div className="forex-take-away-inner">
                    <h4 className="primary-title-forex text-center">
                      Take Away
                    </h4>
                    <p className="primary-content-forex mb-5 text-center">
                      As a leading forex trading software development company,
                      we are committed to delivering innovative, reliable, and
                      secure trading platforms. Our expertise in building forex
                      trading platforms, custom solutions, and MT4 auto trading
                      systems makes us the ideal partner for businesses and
                      traders looking to thrive in the competitive forex market.
                    </p>
                    <p className="primary-content-forex  mb-5 text-center">
                      Contact us today to learn more about how we can help you
                      with forex trading software development and take your
                      business to the next level
                    </p>
                    <div className="text-center">
                      <button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="forex-primary-btn w-btn "
                      >
                        Contact Us
                      </button>
                    </div>
                  </div>
                  <div className="forex-dots">
                    <div className="dots dot-one"></div>
                    <div className="dots dot-two"></div>
                    <div className="dots dot-three"></div>
                    <div className="dots dot-four"></div>
                  </div>
                </div>
              </div>
            </section>
            <section className="bg-white">
              {/* faq */}
              <article className="primary__landing-content-container">
                <div className="landing-faq-wrapper">
                  <div className="row">
                    <div className="col-lg-6">
                      <h6 className="landing-faq-left-title">
                        Frequently Asked{" "}
                        <span className="faq-span">Questions.</span> {""}
                      </h6>
                    </div>
                    <div className="col-lg-6">
                      <div>
                        <div className="container">
                          <div className="accordion" id="faq">
                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead1">
                                <button
                                  className="landing-faq-title collapsed"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#faq1"
                                  aria-expanded="true"
                                  aria-controls="faq1"
                                >
                                  What is forex trading software?
                                </button>
                              </div>

                              <div
                                id="faq1"
                                className="collapse"
                                aria-labelledby="faqhead1"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Forex trading software is a digital platform
                                  that allows users to buy and sell currencies.
                                  It provides tools to analyze markets, execute
                                  trades, and manage accounts.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead2">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq2"
                                  aria-expanded="true"
                                  aria-controls="faq2"
                                >
                                  What services do you offer in forex trading
                                  software development?
                                </div>
                              </div>

                              <div
                                id="faq2"
                                className="collapse"
                                aria-labelledby="faqhead2"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  We offer custom platform development, white
                                  label solutions, MT4 auto trading software,
                                  mobile apps, and API integration for forex
                                  trading platforms.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead3">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq3"
                                  aria-expanded="true"
                                  aria-controls="faq3"
                                >
                                  What is a white label forex trading platform?
                                </div>
                              </div>

                              <div
                                id="faq3"
                                className="collapse"
                                aria-labelledby="faqhead3"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  A white label forex trading platform is a
                                  ready-made software that you can brand and
                                  customize as your own, helping you launch
                                  quickly.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead4">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq4"
                                  aria-expanded="true"
                                  aria-controls="faq4"
                                >
                                  How does MT4 auto trading software work?
                                </div>
                              </div>

                              <div
                                id="faq4"
                                className="collapse"
                                aria-labelledby="faqhead4"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  MT4 auto trading software uses algorithms or
                                  Expert Advisors (EAs) to execute trades
                                  automatically based on pre-set rules without
                                  manual intervention.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead5">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq5"
                                  aria-expanded="true"
                                  aria-controls="faq5"
                                >
                                  Can you develop mobile forex trading apps?
                                </div>
                              </div>

                              <div
                                id="faq5"
                                className="collapse"
                                aria-labelledby="faqhead5"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Yes, we create mobile trading apps with
                                  real-time data, easy navigation, and secure
                                  features for trading on the go.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead6">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq6"
                                  aria-expanded="true"
                                  aria-controls="faq6"
                                >
                                  How long does it take to develop forex trading
                                  software?
                                </div>
                              </div>

                              <div
                                id="faq6"
                                className="collapse"
                                aria-labelledby="faqhead6"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  The timeline varies based on the complexity of
                                  the platform. Custom solutions typically take
                                  several weeks to months, depending on your
                                  needs.
                                </div>
                              </div>
                            </div>

                            <div className="landing-faq-card">
                              <div className="landing-faq-header" id="faqhead7">
                                <div
                                  className="landing-faq-title collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq7"
                                  aria-expanded="true"
                                  aria-controls="faq7"
                                >
                                  How can I get started with forex trading
                                  software development?
                                </div>
                              </div>

                              <div
                                id="faq7"
                                className="collapse"
                                aria-labelledby="faqhead7"
                                data-parent="#faq"
                              >
                                <div className="landing-faq-content">
                                  Contact us to discuss your requirements, and
                                  our team will guide you through the process of
                                  creating your custom forex trading platform.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </section>
          </div>
        </main>
      </main>

      <ServiceFooter />
    </div>
  );
};

export default ForexSolutions;
